// @flow

import * as React from 'react'
import { Overlay } from 'react-bootstrap'
import styled from 'styled-components'

type Props = {
  children: ?React.Node,
  placement: string,
  overlay: ?React.Node,
}

type State = {
  show: boolean,
}

// This component closely mimicks OverlayTrigger[1] with one major difference.
// OverlayTrigger renders overlay to toplevel element created in document,
// but this one renders overlay to its DOM. It means that if user hovers
// over the overlay, leave&enter events are not fired in the containing
// element.
// [1] https://react-bootstrap.github.io/components.html#overlays-trigger-props
class InnerDomOverlayTrigger extends React.Component<Props, State> {
  state = {
    show: false,
  }

  constructor(props: Props) {
    super(props)

    const self: any = this
    self.handleMouseEnter = this.handleMouseEnter.bind(this)
    self.handleMouseLeave = this.handleMouseLeave.bind(this)
    self.handleOverlayHide = this.handleOverlayHide.bind(this)
  }

  handleMouseEnter() {
    this.setState({ show: true })
  }

  handleMouseLeave() {
    this.setState({ show: false })
  }

  handleOverlayHide() {
    this.setState({ show: false })
  }

  render() {
    return (
      <InnerDomOverlayTriggerContainer
        onMouseEnter={this.handleMouseEnter}
        onMouseLeave={this.handleMouseLeave}
      >
        {this.props.children}

        <Overlay
          show={this.state.show}
          onHide={this.handleOverlayHide}
          container={this}
          target={this}
          placement={this.props.placement}
        >
          {this.props.overlay}
        </Overlay>
      </InnerDomOverlayTriggerContainer>
    )
  }
}

const InnerDomOverlayTriggerContainer = styled.div`
  position: relative;
`

export default InnerDomOverlayTrigger
